import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';

const ERROR_MESSAGES = {
  authentication_required: '로그인 세션을 다시 확인해주세요.',
  active_union_membership_required: '활성 유니온 가입 정보가 필요합니다.',
  raid_season_not_found: '선택한 레이드 차수를 다시 확인해주세요.',
  raid_boss_not_found: '선택한 보스를 다시 확인해주세요.',
  target_member_not_found: '현재 유니온 멤버 정보를 찾지 못했습니다.',
  practice_record_not_found: '선택한 내 모의전 슬롯을 다시 확인해주세요.',
  practice_deck_uses_actual_nikke: '실전에 사용한 니케가 포함된 모의전 슬롯은 승인 요청에 사용할 수 없습니다.',
  invalid_custom_order: '덱 이름, 예상 피해량과 니케 5명을 모두 입력해주세요.',
  member_order_already_in_progress: '이미 진행 중이거나 승인 대기 중인 공격 요청이 있습니다.',
  union_manager_required: '공격 요청 승인은 주딱·파딱만 처리할 수 있습니다.',
  attack_request_not_pending: '이미 처리된 공격 요청입니다.',
  attack_request_owner_required: '본인이 등록한 공격 요청만 취소할 수 있습니다.',
};

function client() {
  if (!hasSupabaseConfig || !supabase) throw new Error('서비스 연결 설정을 확인할 수 없습니다.');
  return supabase;
}

function requestError(error, fallback) {
  const raw = String(error?.message || '');
  const code = Object.keys(ERROR_MESSAGES).find((key) => raw.includes(key));
  const next = new Error(ERROR_MESSAGES[code] || raw || fallback);
  next.code = code || error?.code || 'unknown_error';
  return next;
}

export async function requestRaidControlAttack({
  seasonId,
  bossNo,
  phaseNo,
  practiceRecordId = '',
  title,
  expectedDamageEok,
  deck,
  note = '',
}) {
  const savedPracticeRecordId = String(practiceRecordId || '').trim();
  const rpcName = savedPracticeRecordId
    ? 'request_raid_control_attack_from_practice_for_season'
    : 'request_raid_control_attack_for_season';
  const args = savedPracticeRecordId
    ? {
      p_season_id: seasonId,
      p_practice_record_id: savedPracticeRecordId,
      p_phase_no: Number(phaseNo),
      p_note: String(note || '').trim(),
    }
    : {
      p_season_id: seasonId,
      p_boss_no: Number(bossNo),
      p_phase_no: Number(phaseNo),
      p_title: String(title || '').trim(),
      p_expected_damage_eok: Number(expectedDamageEok),
      p_deck: Array.isArray(deck) ? deck.filter(Boolean).slice(0, 5) : [],
      p_note: String(note || '').trim(),
    };
  const { data, error } = await client().rpc(rpcName, args);
  if (error) throw requestError(error, '공격 요청을 등록하지 못했습니다.');
  return String(data?.order_id || data || '');
}

export async function reviewRaidControlAttackRequest(orderId, decision) {
  const { data, error } = await client().rpc('review_raid_control_attack_request', {
    p_order_id: orderId,
    p_decision: decision,
  });
  if (error) throw requestError(error, '공격 요청을 처리하지 못했습니다.');
  return data;
}

export async function cancelRaidControlAttackRequest(orderId) {
  const { data, error } = await client().rpc('cancel_raid_control_attack_request', { p_order_id: orderId });
  if (error) throw requestError(error, '공격 요청을 취소하지 못했습니다.');
  return data;
}
